import gql from 'graphql-tag';

const traceLinkFragment = gql`
  fragment TraceLinkFragment on Link {
    linkHash
    prevLinkHash
    id
    workflowId
    actionKey
    createdAt
    height
    group {
      rowId
      name
      avatar
      label
    }
    processState
    data
    formId
    evidences {
      totalCount
      nodes {
        proof
        provider
        backend
        linkHash
      }
    }
    action {
      key
      title
      icon
      description
      canBeGrouped
      isMigration
      form {
        schema
        uiSchema
      }
      dataImporter
      dataEditor
    }
    references {
      totalCount
      nodes {
        linkHash
        height
        actionKey
        traceId
        action {
          title
        }
        trace {
          name
        }
        workflow {
          rowId
          name
        }
      }
    }
    referencedBy {
      totalCount
      nodes {
        linkHash
        height
        actionKey
        traceId
        action {
          title
        }
        trace {
          name
        }
        workflow {
          rowId
          name
        }
      }
    }
    createdBy {
      name
      avatar
      id
    }
  }
`;

export default {
  traceLink: traceLinkFragment,
  trace: gql`
    fragment TraceInspectorFragment on Trace {
      rowId
      name
      head {
        group {
          rowId
        }
        linkHash
        prevLinkHash
        id
        workflowId
        actionKey
        createdAt
        height
        group {
          rowId
          name
          avatar
          label
        }
        processState
        data
        formId
        evidences {
          totalCount
          nodes {
            proof
            provider
            backend
            linkHash
          }
        }
        action {
          key
          title
          icon
          description
          canBeGrouped
          isMigration
          form {
            schema
            uiSchema
          }
          dataImporter
          dataEditor
        }
        references {
          totalCount
          nodes {
            linkHash
            height
            actionKey
            traceId
            action {
              title
            }
            trace {
              name
            }
            workflow {
              rowId
              name
            }
          }
        }
        referencedBy {
          totalCount
          nodes {
            linkHash
            height
            actionKey
            traceId
            action {
              title
            }
            trace {
              name
            }
            workflow {
              rowId
              name
            }
          }
        }
      }
      workflow {
        config {
          rowId
          info
        }
        rowId
        name
        settings
        groups {
          nodes {
            rowId
            label
            canAct: canActQuick
            name
            avatar
          }
        }
        actions {
          nodes {
            key
            title
            hidden
            isMigration
            answerableComments
          }
        }
      }
      state {
        meta
        data
        rowId
        nextActions
        tasks
        archived
        archivedAt
        manuallyArchived
        trace {
          rowId
          head {
            linkHash
            createdByAccount {
              rowId
              entity {
                ... on Account_User {
                  rowId
                  name
                }
                ... on Account_Bot {
                  rowId
                  name
                }
              }
            }
          }
        }
      }
    }
  `
};
